export default {
  init() {

    // override footer subscribe form
    // #footersubscribe on click or touch or tab-to/focus document.location='/subscribe-to-digital/'
    $('#footersubscribe').on('click touchstart', function(e) {
      e.preventDefault();
      document.location='/subscribe-to-digital/';
    });


    /* Modals
    ---------------------------------------------------------------------------------------------------- */

    $('.open-modal').click(function(e){
      e.preventDefault();
      var selector = $(this).attr('href');
      $(selector).trigger('openModal');
    });

    $('#modal-subscribe').on('initModal', function(){

      var el = $(this);

      $('.form-enews').on('submit', function(e){

        e.preventDefault();

        var formEl = $(this),
            inputEmail = $('input[name*="email"]', formEl),
            inputModalEmail = $('input[name*="email"]', el);

            $(el).trigger('openModal');

            $(inputModalEmail).val($(inputEmail).val());
            $(inputEmail).val('');

      });

      $('.cancel, .overlay', el).on('click', function(e){
        e.preventDefault();
        $(el).trigger('closeModal');
        setTimeout(function() {
          $('.ajax-form', el).trigger('enableForm');
        }, 500);
      });


    }).on('openModal', function(){
      var el = $(this),
          formEl = $('.form', el);
      console.info('openModal', el, formEl);
      var iemail = $('#enews-email').val();
      // make sure it is an email address
      if (iemail.indexOf('@') === -1 || iemail.indexOf('.') === -1) {
        document.location='/subscribe-to-digital/';
      }
      document.location='/subscribe-to-digital/?email='+iemail;

      //$(formEl).trigger('resetForm');
      //$('body').addClass('showing-modal');

    }).on('closeModal', function(){

      $('body').removeClass('showing-modal').addClass('hiding-modal');

      setTimeout(function() {
        $('body').removeClass('showing-modal').removeClass('hiding-modal');
      }, 500);


    }).trigger('initModal');


    /* Forms
    ---------------------------------------------------------------------------------------------------- */

    $('select.input-select').customSelect();
    $('.input-radio').iCheck();
    $('.label-checkbox .input-checkbox').iCheck();


    /* AJAX Form
    ---------------------------------------------------------------------------------------------------- */

    $('.ajax-form')
      .on('formInit', function(){
        var el = $(this);

        $('.input-text, .input-select', el).trigger('blur');

        var buttonEl = $(el).find('.submit'),
            messageEl = $(el).find('.description');

        // Store message's current text as the default text
        $(messageEl).data('default-text', $(messageEl).text());
        $(buttonEl).data('default-label', $(buttonEl).text());

        $('input, .customSelect, textarea', el).on('focus', function(){

          var message = $(messageEl).data('default-text'),
              label   = $(buttonEl).data('default-label');

            if(!message.length) {
              message = '';
            }

            if(!label.length) {
              label = 'Subscribe';
            }

          $(buttonEl).removeAttr('disabled').text(label);
          $(el).removeClass('with-errors').removeClass('with-success');

        });

      })

      .submit(function(e){

        e.preventDefault();
        var el         = $(this),
            dataSource = $(el).attr('action');

        if($(el).hasClass('is-sending')) {
          return;
        }

        $(el).trigger('disableForm').removeClass('with-errors');

        var formData = jQuery(el).serialize();
        console.info('formdata',formData, dataSource);

        $.ajax({
            url: dataSource,
            type: 'POST',
            data:formData,
            success: function(data){
              console.info('success response',data);
              if (typeof data === 'undefined') {
                setTimeout(function() {
                  $(el).trigger('showErrors', 'An error occured');
                  $(window).trigger('resize');
                }, 500);
                return;
              }

              setTimeout(function() {

                var methodToTrigger = (data.success) ? 'showSuccess' : 'showErrors';
                $(el).trigger(methodToTrigger, data.message);

                if (data.success && (typeof data.url !== 'undefined') && data.url.length) {
                  window.location.replace(data.url);
                }

              }, 500);

            }, error: function(e) {
              console.info('error response',e);
            setTimeout(function() {
              $(el).trigger('showErrors', 'An error occured');
            }, 500);

          },

        });

      })

      .on('disableForm', function(){

        var el = $(this),
            buttonEl = $(el).find('.submit');

        $(buttonEl).attr('disabled','disabled').text('Sending...');
        $(el).addClass('is-sending').removeClass('with-success').removeClass('with-errors');

      })

      .on('showSuccess', function(e, successMessage){ // eslint-disable-line

        var el = $(this),
            buttonEl = $(el).find('.submit'),
            cancelButton = $(el).find('.cancel');

        $(buttonEl).removeAttr('disabled');

        $(el).trigger('enableForm').removeClass('with-errors').addClass('with-success');
        $(buttonEl).text('Success');
        $(cancelButton).text('Done');


        // Reset Data
        $(el)[0].reset();

        setTimeout(function() {
          $('#modal-subscribe').trigger('closeModal');
        }, 2000);

      })

      .on('showErrors', function(e, errorMessage){
        var el = $(this),
            buttonEl = $(el).find('.submit'),
            messageEl = $(el).find('.description');

        $(el).removeClass('is-sending').removeClass('with-success').addClass('with-errors');

        setTimeout(function() {
          $(buttonEl).removeAttr('disabled').text('Errors Found');
          $(messageEl).text(errorMessage);
        }, 250);

      })

      .on('enableForm', function(){
        var el = $(this),
            buttonEl = $(el).find('.submit'),
            label = $(buttonEl).data('default-label');

          if(!label.length) {
            label = 'Submit';
          }

        $(buttonEl).removeAttr('disabled').text(label);
        $(el).removeClass('is-sending');

      })

      .on('resetForm', function(){

        var el = $(this),
            buttonEl = $(el).find('.submit'),
            messageEl = $(el).find('.description'),
            label = $(buttonEl).data('default-label'),
            message = $(messageEl).data('default-text');

          if(!label.length) {
            label = 'Submit';
          }

        $(el)[0].reset();

        $(buttonEl).removeAttr('disabled').text(label);
        $(messageEl).text(message);
        $(el).removeClass('is-sending').removeClass('with-errors').removeClass('with-success');

      })

      .trigger('formInit');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js